import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import { History as HistoryIcon } from "lucide-react";

export default function History() {
  const [history, setHistory] = useState([]);
  useEffect(() => {
    api.get("/history").then((r) => setHistory(r.data.history || [])).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
        <div className="flex items-center gap-3">
          <HistoryIcon className="w-6 h-6 text-emerald-400" />
          <h1 className="font-display text-3xl font-bold text-white">Histórico de pesquisas</h1>
        </div>
        <div className="mt-6 rounded-xl bg-slate-900/70 border border-slate-800 divide-y divide-slate-800">
          {history.length === 0 ? (
            <div className="p-8 text-center text-slate-400 text-sm">Nenhuma pesquisa ainda.</div>
          ) : history.map((h) => (
            <div key={h._id} className="p-4 flex justify-between items-center" data-testid={`history-item-${h._id}`}>
              <div>
                <div className="text-sm text-slate-200 font-mono">
                  {Object.entries(h.filters || {}).filter(([, v]) => v && v !== "all").map(([k, v]) => `${k}: ${v}`).join(" · ") || "Todos os filtros"}
                </div>
                <div className="text-xs text-slate-500 mt-1">{new Date(h.created_at).toLocaleString("pt-BR")}</div>
              </div>
              <div className="text-right text-sm">
                <div className="font-mono text-emerald-400 font-bold">{h.results_count} lotes</div>
                <div className="text-xs text-slate-500">−{h.credits_used} crédito</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
